import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BrandBadge } from "@/components/BrandBadge";

const VENDOR_META = {
  Salesforce: { blurb: "Administrator, Sales Cloud and Service Cloud." },
  AWS: { blurb: "Cloud Practitioner and Solutions Architect – Associate." },
  Mulesoft: { blurb: "Integration Developer with API-led connectivity and DataWeave." },
  IBM: { blurb: "CICS with Web Services and WebSphere MQ administration." },
};

export default function VendorBento({ courses }) {
  const grouped = courses.reduce((acc, c) => {
    (acc[c.vendor] = acc[c.vendor] || []).push(c);
    return acc;
  }, {});
  const vendors = ["Salesforce", "AWS", "Mulesoft", "IBM"];

  return (
    <section data-testid="courses-bento" className="mx-auto max-w-7xl px-6 lg:px-10 py-20 md:py-28">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
        <div>
          <div className="text-xs uppercase tracking-widerest text-slate-500 font-mono-plex">Explore courses</div>
          <h2 className="mt-3 font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl text-slate-950 max-w-2xl">
            Four ecosystems. One clear path to certification.
          </h2>
        </div>
        <Link
          to="/courses"
          data-testid="bento-view-all-courses"
          className="inline-flex items-center gap-2 text-sm font-medium text-slate-900 hover:text-[#0052FF] transition-colors self-start md:self-end"
        >
          View full catalog <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-12 gap-6">
        {vendors.map((v, idx) => {
          const meta = VENDOR_META[v];
          const cs = grouped[v] || [];
          const span = idx === 0 ? "lg:col-span-7" : idx === 1 ? "lg:col-span-5" : idx === 2 ? "lg:col-span-5" : "lg:col-span-7";
          return (
            <Link
              key={v}
              to={`/courses?vendor=${encodeURIComponent(v)}`}
              data-testid={`bento-vendor-${v.toLowerCase()}`}
              className={`group md:col-span-2 ${span} border border-slate-200 bg-white p-6 md:p-8 hover:-translate-y-1 hover:shadow-lg transition-all`}
            >
              <div className="flex items-start justify-between gap-4">
                <BrandBadge vendor={v} size={48} />
                <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-slate-900 transition-colors" />
              </div>
              <div className="mt-6">
                <h3 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-slate-950">{v}</h3>
                <p className="mt-2 text-sm text-slate-600 max-w-md">{meta.blurb}</p>
              </div>
              <div className="mt-6 flex flex-wrap gap-2">
                {cs.slice(0, 3).map((c) => (
                  <span key={c.id} className="text-xs px-2.5 py-1 border border-slate-200 text-slate-700 bg-slate-50">
                    {c.title}
                  </span>
                ))}
                {cs.length > 3 && (
                  <span className="text-xs px-2.5 py-1 border border-slate-200 text-slate-700 bg-slate-50">
                    +{cs.length - 3} more
                  </span>
                )}
              </div>
              <div className="mt-8 flex items-end justify-between border-t border-slate-100 pt-4">
                <div>
                  <div className="text-[11px] uppercase tracking-widerest text-slate-500 font-mono-plex">Fee</div>
                  <div className="font-display font-bold text-slate-950">
                    ₹19,999<span className="text-xs font-normal text-slate-500"> + GST (India)</span>
                    <div className="text-xs font-normal text-slate-500 mt-0.5">$499 (Global)</div>
                  </div>
                </div>
                <div className="text-xs text-slate-500">{cs.length} course{cs.length !== 1 ? "s" : ""}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
